<div class="container">
  <h3 class="text-primary ab_left_text">SECURITY UTILITY MANAGER
  </h3>
  <blockquote class="generic-blockquote">
    Compliance Planet includes amongCompliance Planet includes amongst it’s features a security manager from which
    users are authorised and authenticated. It also enables creation and assigning of roles to users. It also keeps a
    track of <strong>who did what; where and when</strong> and provide security report.
  </blockquote>
</div>